import { render, staticRenderFns } from "./edit-address-dialog.vue?vue&type=template&id=5e61ba69&scoped=true"
import script from "./edit-address-dialog.vue?vue&type=script&lang=js"
export * from "./edit-address-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-address-dialog.vue?vue&type=style&index=0&id=5e61ba69&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e61ba69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e61ba69')) {
      api.createRecord('5e61ba69', component.options)
    } else {
      api.reload('5e61ba69', component.options)
    }
    module.hot.accept("./edit-address-dialog.vue?vue&type=template&id=5e61ba69&scoped=true", function () {
      api.rerender('5e61ba69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/address/edit-address-dialog.vue"
export default component.exports